module.exports = {
  AUTH_URL: `${process.env.REACT_APP_AUTH_URL}`,
};
